import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from '@nuxtjs/composition-api';
import type { BravadoSelectDropdownOptionImage } from './types';
import { ImageShape, PossibleImagePlaceholder } from './types';
import BuildingIcon from '@/assets/svg/building.vue.svg';
import PlaceholderImageIcon from '@/assets/svg/placeholder-image.vue.svg';

type BravadoSelectDropdownImageProps = {
  image: BravadoSelectDropdownOptionImage;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BravadoSelectDropdownImage',
  props: {
    image: null
  },
  setup(__props: any) {

const props = __props as {
  image: BravadoSelectDropdownOptionImage;
};



const imageHasError = ref(false);

function onError() {
  imageHasError.value = true;
}

const placeholder = computed(() => {
  return props.image.placeholder || PossibleImagePlaceholder.default;
});
const isPlaceholderImage = computed(() => imageHasError.value || placeholder.value !== PossibleImagePlaceholder.user);
const placeholderComponent = computed(() =>
  placeholder.value === PossibleImagePlaceholder.company ? BuildingIcon : PlaceholderImageIcon,
);
const rootClasses = computed(() => ({
  'bravado-select-dropdown-image': true,
  'bravado-select-dropdown-image--rounded': props.image.shape === ImageShape.rounded,
  'bravado-select-dropdown-image--circle': props.image.shape === ImageShape.circle,
}));

return { __sfc: true,props, imageHasError, onError, placeholder, isPlaceholderImage, placeholderComponent, rootClasses }
}

})